export const INSURANCE_AGENT_BOOKING_URL =
  'https://tuclinicahispanafamiliar.com/en/booking-page/'

export function leaveForBookingPage(location, next) {
  location.replace(INSURANCE_AGENT_BOOKING_URL)
  next(false)
}
